import { z } from 'zod';

export const quoteFormSchema = z.object({
  // Contact Information
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  phone: z.string().min(10, 'Phone number is required'),

  // Rental Details
  rentalDate: z.string().min(1, 'Rental start date is required'),
  returnDate: z.string().min(1, 'Return date is required'),
  cartSize: z.enum(['2', '4', '6', 'unsure'], {
    message: 'Please select a cart size',
  }),
  cartType: z.enum(['electric', 'gas', '']).optional(),
  quantity: z.coerce.number().min(1).default(1),

  // Delivery Location
  streetAddress: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zipCode: z.string().optional(),
  deliveryTime: z.enum(['morning', 'afternoon', 'evening', '']).optional(),

  // Additional Information
  comments: z.string().optional(),
  childSeats: z.boolean().optional(),
  accessories: z.boolean().optional(),
  eventRental: z.boolean().optional(),
});

export type QuoteFormData = z.infer<typeof quoteFormSchema>;